import { connect } from 'react-redux';
import { connect as connectRefetch } from 'react-refetch';
import { compose } from 'recompose';

import { getProjectsCached } from '../../redux/actions/project';
import { StoreState } from '../../redux/reducers/store.types';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';

import { ProjectOverviewContainerProps } from './project-overview.container';
import { ProjectOverviewLazyLoadContainer } from './project-overview.lazy';

export const ProjectOverviewDataLoader = compose<
  ProjectOverviewContainerProps,
  {}
>(
  connect(
    (state: StoreState) => ({
      organizationId: getSelectedOrganizationId(state),
    }),
    {
      getProjectsCached,
    },
  ),
  connectRefetch(({ getProjectsCached, organizationId }) => ({
    getProjectsFetch: {
      value: () => getProjectsCached(organizationId),
      comparison: organizationId,
    },
  })),
)(ProjectOverviewLazyLoadContainer);
